import React from 'react';
import { CollectionPath } from '@typings/collections.enum';
import { useCollection, useDocument } from '@nandorojo/swr-firestore';
import { User } from '@typings/setting/userType.interface';
import { InfoSec } from './DetailStyle';
import CommentIcon from '@components/dataDisplay/Icons/CommentIcon';
import { ACCESS_TYPE } from '@typings/common/accessType';
import TimeAgo from '@components/dataDisplay/TimeAgo';
import { useRecoilValue } from 'recoil';
import { isMasterState } from '@atom/setting/user';
import { IcommentItem } from '@typings/common/comment.interface';
import { IpostingItem } from '@typings/posting/posting.interface';
import LockIcon from '@template/GuardItem/LockIcon';
import styled from 'styled-components';

const Wrap = styled.div`
  display: flex;
  align-items: center;
`;

const ControlWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

const TextControlButton = styled.button`
  color: var(--subTextColor);
  font-size: 12px;
  line-height: 1;

  &:hover {
    color: var(--textColor);
  }
`;

interface Props {
  data: IpostingItem;
  noAuthor?: boolean;
  omission?: boolean;
  collectionPath?: string;
  showControlText?: boolean;
  onClickEdit?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onClickDelete?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

function PostingInfoSec({
  data,
  omission,
  noAuthor,
  collectionPath,
  showControlText = false,
  onClickEdit,
  onClickDelete,
}: Props) {
  const { authorUid, createdAt, accessType, password, id } = data;
  const authorSnapshot = data.authorSnapshot;
  const { data: authorData } = useDocument<User>(
    authorSnapshot ? null : `${CollectionPath.USERS}/${authorUid}`,
    { listen: true },
  );

  // comment
  const { data: commentData } = useCollection<IcommentItem>(
    `${collectionPath}Comment`,
    { listen: true, where: ['boardId', '==', id] },
  );

  return (
    <InfoSec>
      {!noAuthor && (
        <Wrap>
          <strong>
            {authorSnapshot?.displayName || authorData?.displayName}
          </strong>
          &nbsp;•&nbsp;
        </Wrap>
      )}
      <div>{createdAt && <TimeAgo createdAt={createdAt} />}</div>

      {!omission && (
        <>
          <Wrap>
            <span>&nbsp;•&nbsp;</span>
            <CommentIcon count={commentData ? commentData.length : 0} />
          </Wrap>
          {showControlText && (
            <ControlWrap>
              <span>&nbsp;•&nbsp;</span>
              <TextControlButton type="button" onClick={onClickEdit}>
                수정
              </TextControlButton>
              <TextControlButton type="button" onClick={onClickDelete}>
                삭제
              </TextControlButton>
            </ControlWrap>
          )}
        </>
      )}
      <AccessTypeSec accessType={accessType} password={password} />
    </InfoSec>
  );
}

function AccessTypeSec({ accessType, password }) {
  const isMaster = useRecoilValue(isMasterState);

  if (accessType === ACCESS_TYPE.PUBLIC) return null;
  return (
    <Wrap>
      &nbsp;•&nbsp;
      {accessType === ACCESS_TYPE.PASSWORD && isMaster ? (
        <>비밀번호 {password}</>
      ) : (
        <LockIcon accessType={accessType} />
      )}
    </Wrap>
  );
}

export default PostingInfoSec;
